module.exports = __webpack_public_path__ + "img/server.9aec6d1d.png";